<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields['title'] }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div>
          <label class="label-input">Section Title</label>
          <v-text-field v-model="fields.title" label="Title" />
        </div>

        <!-- Section Colors -->
        <div>
          <v-row>
            <v-col cols="6">
              <div class="d-flex align-center gap-3 mb-5">
                <input
                  type="color"
                  name="text-color"
                  style="width: 40px; height: 40px; margin-right: 12px"
                  :value="fields['text-color']"
                  @change="handleChangeTextColor"
                />
                <v-text-field v-model="fields['text-color']" label="Text Color" />
                <v-btn @click="handleResetTextColor" small text color="primary"> Reset </v-btn>
              </div>
            </v-col>
            <v-col cols="6">
              <div class="d-flex align-center gap-3 mb-5">
                <input
                  type="color"
                  name="head"
                  style="width: 40px; height: 40px; margin-right: 12px"
                  :value="fields['card-container']"
                  @change="event => handleChangeBackground(event)"
                />
                <v-text-field v-model="fields['card-container']" label="Background Color" />
              </div>
            </v-col>
          </v-row>
        </div>
        <div>
          <div class="d-flex justify-space-between align-center">
            <label class="label-input">Content</label>
            <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
              <input type="checkbox" v-model="fields['style-center-y']" id="style-center-y" />
              <label for="style-center-y" style="margin-bottom: 0">Style center Y</label>
            </div>
          </div>
          <div class="mb-6 wrap-title-card">
            <label>Title</label>
            <ckeditor :editor="editor" v-model="fields['card-title']" :config="editorConfig" />
          </div>
          <div class="mb-6">
            <label>Description</label>
            <ckeditor :editor="editor" v-model="fields['card-description']" :config="editorConfig" />
          </div>
          <div>
            <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
              <label for="showBtn" style="margin-bottom: 0" class="label-input">Button</label>
              <input type="checkbox" v-model="fields.buttonCard.show" id="showBtn" />
            </div>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field v-model="fields.buttonCard.text" label="Button Text" />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field type="number" v-model="fields.buttonCard.radius" label="Button Radius" />
              </v-col>
              <v-col cols="12" md="6">
                <div>
                  <div>
                    <div class="d-flex align-center gap-3">
                      <input
                        type="color"
                        name="head"
                        style="width: 40px; height: 40px; margin-right: 12px"
                        :value="fields.buttonCard.color"
                        @change="event => handleChangeColorButton(event)"
                      />
                      <v-text-field v-model="fields.buttonCard.color" label="Button Color" />
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div>
                  <div>
                    <div class="d-flex align-center gap-3">
                      <input
                        type="color"
                        name="head"
                        style="width: 40px; height: 40px; margin-right: 12px"
                        :value="fields.buttonCard.background"
                        @change="event => handleChangeBackgroundButton(event)"
                      />
                      <v-text-field v-model="fields.buttonCard.background" label="Button Color" />
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="fields.buttonCard.link" label="Button Link" />
              </v-col>
            </v-row>
          </div>
          <div>
            <label class="label-input">Image</label>
            <v-select
              :value="fields['card-item-image']"
              :items="postionOptions"
              label="Position"
              @change="handleChangePosition"
            />
            <div>
              <UploadImage
                @callback="handleUploadImage"
                :image="{ imageSrc: fields['card-image'] }"
                :height="`250`"
                :typeUpload="'image'"
                @callbackDelete="handleRemoveUpload"
              />
            </div>
          </div>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '../common/html/update';
import UploadImage from '../common/form/upload-file/upload-image.vue';
export default {
  name: 'card-sona-section-editor',
  components: {
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      postionOptions: [
        {
          text: 'Left',
          value: 1,
        },
        {
          text: 'Right',
          value: 2,
        },
      ],
      fields: {
        title: '',
        'text-color': '#000000',
        'button-text-color': '#ffffff',
        'card-container': '',
        'card-item-image': '',
        'card-item-content': '',
        'card-image': '',
        'card-title': '',
        'card-description': '',
        'style-center-y': '',
        buttonCard: {
          show: true,
          background: '#000000',
          color: '#FFFFFF',
          radius: 0,
          text: '',
          link: '',
        },
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionCardSona(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields['title'],
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleChangeBackground(event) {
      this.fields['card-container'] = event.target.value;
    },
    handleChangeColorButton(event) {
      this.fields.buttonCard.color = event.target.value;
    },
    handleChangeBackgroundButton(event) {
      this.fields.buttonCard.background = event.target.value;
    },
    handleChangePosition(value) {
      this.fields['card-item-image'] = Number(value);
      if (value === 1) {
        this.fields['card-item-content'] = 2;
      } else {
        this.fields['card-item-content'] = 1;
      }
    },
    handleUploadImage(obj) {
      let url = obj.imageSrc;
      this.fields['card-image'] = url;
    },
    handleRemoveUpload() {
      this.fields['card-image'] = '';
    },
    handleChangeTextColor(event) {
      this.fields['text-color'] = event.target.value;
    },
    handleChangeButtonTextColor(event) {
      this.fields['button-text-color'] = event.target.value;
    },
    handleResetTextColor() {
      this.fields['text-color'] = '#000000';
    },
    handleResetButtonTextColor() {
      this.fields['button-text-color'] = '#ffffff';
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap-title-card {
  .ck-editor__editable_inline {
    min-height: 150px;
  }

  .ck-editor__editable {
    min-height: 150px;
  }
}

.ck-editor__editable_inline {
  min-height: 300px;
}

.ck-editor__editable {
  min-height: 300px;
}

.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}

.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}

.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
